export default __webpack_public_path__ + "static/media/thumbnail.de5cb5cc.png";